<script setup lang="ts">
import type { JSX } from '@ionic/core'

const modelValue = defineModel<string>()
const props = defineProps<JSX.IonInput & {
	isRequired?: boolean
}>()
</script>

<template>
	<VCIFormItem
		v-bind="$attrs"
		:readonly="readonly"
		:error="!!errorText"
	>
		<VCIDateInput
			v-model="modelValue"
			v-bind.attr="$attrs"
			v-bind.prop="{ ...props, errorText: undefined }"
		/>
		<i
			v-if="!!readonly"
			slot="end"
			class="mdi mdi-lock"
		/>
	</VCIFormItem>
	<VCIFormItem
		v-if="!!errorText"
	>
		<span class="error-text">{{ errorText }}</span>
	</VCIFormItem>
</template>

<style lang="scss" scoped>
ion-item:deep(ion-input) {
	.label-text-wrapper {
		min-width: 20%;

		.label-text {
			white-space: normal;
			font-size: 10px
		}
	}
	&:deep(input[type="date"]) {
		display: flex;
	}
}
.error-text {
	font-size: 10px;
	font-weight: normal;
	transform: translateY(-10px);
}
</style>
